import { cn } from "@/app/utils/cn"

type Step = {
  label: string
}

type StepperProps = {
  steps: Step[]
  currentStep: number 
  onClick?: (step: number) => void
}

export function Stepper({ steps, currentStep, onClick }: StepperProps) {
  return (
    <div className="flex items-start w-full">
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const isCompleted = stepNumber < currentStep
        const isActive = stepNumber === currentStep
        const isLast = index === steps.length - 1

        return (
          <div
            key={index}
            onClick={() => onClick && onClick(stepNumber)}
            className={cn(
              "relative flex flex-col items-center",
              isLast ? "flex-none" : "flex-1"
            )}
          >
            {!isLast && (
              <div className="absolute top-4 left-1/2 w-full h-0.5 overflow-hidden">
                <div className="absolute inset-0 bg-zinc-300" />
                <div
                  className={cn(
                    "absolute inset-y-0 left-0 bg-emerald-500 transition-all duration-500",
                    isCompleted && "w-full",
                    isActive && "w-1/2",
                    !isCompleted && !isActive && "w-0"
                  )}
                />
              </div>
            )}

            <div
              className={cn(
                "relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-xs border-2 transition-all duration-300 bg-white font-semibold",
                isCompleted || isActive
                  ? "border-emerald-500 text-emerald-500"
                  : "border-zinc-300 text-zinc-400"
              )}
            >
              {stepNumber}
            </div>

            <span
              className={cn(
                "mt-1.5 text-[10px] sm:text-xs whitespace-nowrap font-semibold text-gray-600",
              )}
            >
              {step.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}